import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';

const FIELDS = [
  { group: 'Hero', items: [
    { key: 'hero_title_line1', label: 'Judul Baris 1 (misal: BLAST)', type: 'text' },
    { key: 'hero_title_line2', label: 'Judul Baris 2 (misal: MOTOR CLUB)', type: 'text' },
    { key: 'hero_eyebrow', label: 'Label Kecil di Atas Judul', type: 'text' },
    { key: 'hero_subtitle', label: 'Subjudul / Deskripsi', type: 'textarea' },
    { key: 'hero_cta_text', label: 'Teks Tombol Gabung', type: 'text' },
  ]},
  { group: 'Roster (Daftar Member)', items: [
    { key: 'roster_eyebrow', label: 'Label Kecil', type: 'text' },
    { key: 'roster_title', label: 'Judul Section', type: 'text' },
  ]},
  { group: 'Event / Touring', items: [
    { key: 'event_eyebrow', label: 'Label Kecil', type: 'text' },
    { key: 'event_title', label: 'Judul Section', type: 'text' },
  ]},
  { group: 'Galeri', items: [
    { key: 'galeri_eyebrow', label: 'Label Kecil', type: 'text' },
    { key: 'galeri_title', label: 'Judul Section', type: 'text' },
  ]},
  { group: 'Papan Pesan', items: [
    { key: 'message_eyebrow', label: 'Label Kecil', type: 'text' },
    { key: 'message_title', label: 'Judul Section', type: 'text' },
  ]},
  { group: 'Partners / Sponsor', items: [
    { key: 'partners_eyebrow', label: 'Label Kecil', type: 'text' },
    { key: 'partners_title', label: 'Judul Section', type: 'text' },
  ]},
  { group: 'Footer', items: [
    { key: 'footer_text', label: 'Teks Copyright', type: 'text' },
  ]},
];

export default function SiteContent() {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savedMsg, setSavedMsg] = useState('');

  useEffect(() => {
    api.get('/site-content')
      .then((res) => setContent(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (key, value) => {
    setContent((prev) => ({ ...prev, [key]: value }));
  };

  const handleSaveAll = async () => {
    setSaving(true);
    setSavedMsg('');
    try {
      await api.put('/site-content', content);
      setSavedMsg('Semua perubahan tersimpan ✓');
      setTimeout(() => setSavedMsg(''), 3000);
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = { background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '10px 12px', color: '#F0EDE4', fontSize: 14, width: '100%' };

  if (loading) return <Layout><p style={{ color: '#8B92A0' }}>Memuat...</p></Layout>;

  return (
    <Layout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 10 }}>
        <h1 style={{ fontSize: 28, fontWeight: 900, fontStyle: 'italic' }}>Konten Beranda</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {savedMsg && <span style={{ color: '#4ADE80', fontSize: 13 }}>{savedMsg}</span>}
          <button
            onClick={handleSaveAll}
            disabled={saving}
            style={{ background: '#D02127', color: '#fff', border: 'none', padding: '10px 24px', borderRadius: 6, fontWeight: 700, cursor: 'pointer' }}
          >
            {saving ? 'Menyimpan...' : 'Simpan Semua'}
          </button>
        </div>
      </div>

      <p style={{ color: '#8B92A0', fontSize: 13, marginBottom: 24 }}>
        Ubah teks yang tampil di halaman beranda publik. Perubahan langsung tampil setelah disimpan (tanpa perlu build ulang).
      </p>

      {FIELDS.map((group) => (
        <div key={group.group} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 20, marginBottom: 16, maxWidth: 560 }}>
          <h2 style={{ fontSize: 15, fontWeight: 800, marginBottom: 14, color: '#D02127' }}>{group.group}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {group.items.map((field) => (
              <div key={field.key}>
                <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>{field.label}</label>
                {field.type === 'textarea' ? (
                  <textarea
                    value={content[field.key] || ''}
                    onChange={(e) => handleChange(field.key, e.target.value)}
                    rows={3}
                    style={inputStyle}
                  />
                ) : (
                  <input
                    value={content[field.key] || ''}
                    onChange={(e) => handleChange(field.key, e.target.value)}
                    style={inputStyle}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}

      <button
        onClick={handleSaveAll}
        disabled={saving}
        style={{ background: '#D02127', color: '#fff', border: 'none', padding: '12px 28px', borderRadius: 6, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}
      >
        {saving ? 'Menyimpan...' : 'Simpan Semua'}
      </button>
    </Layout>
  );
}
